import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  useTheme,
} from '@mui/material';
import LocalHotelIcon from '@mui/icons-material/LocalHotel';

const Facilities = ({ data }) => {
  const theme = useTheme();

  return (
    <Card elevation={3} sx={{ mb: 4, backgroundColor: theme.palette.gery.white }}>
      <CardContent>
        <Typography variant="h3" color="text.primary" display="flex" alignItems="center" gutterBottom>
          <LocalHotelIcon sx={{ mr: 1, color: theme.palette.action.purpleLight }} fontSize="small" />
          Clinic Facilities
        </Typography>

        {Array.isArray(data) && data.length > 0 ? (
          <List dense>
            {data.map((facility, index) => (
              <React.Fragment key={index}>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={
                      <Typography variant="smallMedium" color="text.primary">
                        {facility.name}
                      </Typography>
                    }
                    secondary={
                      <Typography variant="smallRegular" color="text.secondary">
                        {facility.value}
                      </Typography>
                    }
                  />
                </ListItem>
                {index < data.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        ) : (
          <Typography variant="smallRegular" color="text.secondary">
            No facilities listed.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default Facilities;
